// extracted by mini-css-extract-plugin
export var avatarContainer = "_9b-0";
export var avatarTypingWave = "_9b-i";
export var gray = "_9b-f";
export var green = "_9b-c";
export var icon = "_9b-9";
export var image = "_9b-1";
export var lg = "_9b-6";
export var md = "_9b-5";
export var presenceDot = "_9b-b";
export var red = "_9b-d";
export var sm = "_9b-4";
export var status = "_9b-a";
export var typingDot = "_9b-h";
export var typingPill = "_9b-g";
export var xl = "_9b-7";
export var xs = "_9b-3";
export var xxl = "_9b-8";
export var xxs = "_9b-2";
export var yellow = "_9b-e";